import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface CorpInfoStateIF {
  type: string;
  corpNumberState: string;
  companyNameState: string;
  companyNameEngState: string;
  companyNameKanaState: string;
  corporateNameDetail: string;
  postalCode: string;
  prefectures: string;
  prefecturesKana: string;
  city: string;
  cityKana: string;
  oaza: string;
  oazaKana: string;
  azaChome: string;
  azaChomeKana: string;
  banchi: string;
  banchiKana: string;
  buildingName: string;
  buildingNameKana: string;
  phoneNumber: string;
  url: string;
  repName: string;
  repNameKana: string;
  repNameEng: string;
  birthday: string;
  repCountry: string;
  isInclusionMerchant: boolean;
  merchants: string;
}

const initialState = {
  type: "",
  corpNumberState: "",
  companyNameState: "",
  companyNameEngState: "",
  companyNameKanaState: "",
  corporateNameDetail: "",
  postalCode: "",
  prefectures: "",
  prefecturesKana: "",
  city: "",
  cityKana: "",
  oaza: "",
  oazaKana: "",
  azaChome: "",
  azaChomeKana: "",
  banchi: "",
  banchiKana: "",
  buildingName: "",
  buildingNameKana: "",
  phoneNumber: "",
  url: "",
  repName: "",
  repNameKana: "",
  repNameEng: "",
  birthday: "",
  repCountry: "",
  isInclusionMerchant: true,
  merchants: "",
} as CorpInfoStateIF;

const corpInfoSlice = createSlice({
  name: "corpInfoSlice",
  initialState,
  reducers: {
    showCorpInfoModal: (
      state,
      action: PayloadAction<{
        type: string;
        corpNumberState: string;
        companyNameState: string;
        companyNameEngState: string;
        companyNameKanaState: string;
        corporateNameDetail: string;
        postalCode: string;
        prefectures: string;
        prefecturesKana: string;
        city: string;
        cityKana: string;
        oaza: string;
        oazaKana: string;
        azaChome: string;
        azaChomeKana: string;
        banchi: string;
        banchiKana: string;
        buildingName: string;
        buildingNameKana: string;
        phoneNumber: string;
        url: string;
        repName: string;
        repNameKana: string;
        repNameEng: string;
        birthday: string;
        repCountry: string;
        isInclusionMerchant: boolean;
        merchants: string;
      }>
    ) => {
      const {
        type,
        corpNumberState,
        companyNameState,
        companyNameEngState,
        companyNameKanaState,
        corporateNameDetail,
        postalCode,
        prefectures,
        prefecturesKana,
        city,
        cityKana,
        oaza,
        oazaKana,
        azaChome,
        azaChomeKana,
        banchi,
        banchiKana,
        buildingName,
        buildingNameKana,
        phoneNumber,
        url,
        repName,
        repNameKana,
        repNameEng,
        birthday,
        repCountry,
        isInclusionMerchant,
        merchants,
      } = action.payload;
      state.type = type;
      state.corpNumberState = corpNumberState;
      state.companyNameState = companyNameState;
      state.companyNameEngState = companyNameEngState;
      state.companyNameKanaState = companyNameKanaState;
      state.corporateNameDetail = corporateNameDetail;
      state.postalCode = postalCode;
      state.prefectures = prefectures;
      state.prefecturesKana = prefecturesKana;
      state.city = city;
      state.cityKana = cityKana;
      state.oaza = oaza;
      state.oazaKana = oazaKana;
      state.azaChome = azaChome;
      state.azaChomeKana = azaChomeKana;
      state.banchi = banchi;
      state.banchiKana = banchiKana;
      state.buildingName = buildingName;
      state.buildingNameKana = buildingNameKana;
      state.phoneNumber = phoneNumber;
      state.url = url;
      state.repName = repName;
      state.repNameKana = repNameKana;
      state.repNameEng = repNameEng;
      state.birthday = birthday;
      state.repCountry = repCountry;
      state.isInclusionMerchant = isInclusionMerchant;
      state.merchants = merchants;
    },
  },
});

export const { showCorpInfoModal } = corpInfoSlice.actions;

export default corpInfoSlice.reducer;
